import { useEffect } from "react";

import { isBrowser } from "@shared/utils.environment";

import { useUser } from "lib/apollo/hooks";
import type { RegionType } from "@shared/graphql.apollo";
import type { User } from "@shared/utils.user";
import { useRouter } from "lib/router";
import { initGTM, useIsGTMEnabled } from "utils/gtm";
import { initGTMImpressions } from "utils/gtm/impressions";
import { useCurrencyCode } from "./useCurrencyCode";
import { getRegion } from "@shared/utils.locale";

const useServerGTM = () => {
  return null;
};

const useClientGTM = (eventId, is404 = false): void => {
  const { asPath } = useRouter();
  const region = getRegion();
  const isGTMEnabled = useIsGTMEnabled();
  const user = useUser();
  const currencyCode = useCurrencyCode();

  useEffect(() => {
    if (isGTMEnabled) {
      initGTM(region as RegionType, asPath, user as User, eventId, is404);
      initGTMImpressions(currencyCode);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [region, user, asPath, currencyCode]);
};

export const useGTM = isBrowser() ? useClientGTM : useServerGTM;
